/**
 * @fileoverview Logic component of the ReduxModal, operates all logic and completely controls view component
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReduxModalView from '../component/ReduxModalView'
import { hideReduxModal, resetReduxModal } from '../../../Reducers/UI/actions'

/**
 * Logic container for ReduxModal
 *
 * @param {boolean} props.show Indicates whether modal should be visible
 * @param {string} props.title Modal's title
 * @param {function} props.handleConfirm Action of the confirm button
 * @param {string} props.confirmLabel Label of the confirm button
 * @param {function} props.handleCancel Action of the cancel button
 * @param {string} props.cancelLabel Label of the cancel button
 * @param {array} props.children Component's children that will be rendered in the middle of the view
 * @param {boolean} props.confirmDisabled Indicates whether confirm button should be disabled
 * @param {boolean} props.hideCancel Indicates whether cancel button should be hidden
 * @param {boolean} props.hideTitle Indicates whether title should be hidden
 * @param {boolean} props.hideButtons Indicates whether all footer buttons should be hidden
 *
 * @returns {JSX.Element}
 */
class ReduxModal extends Component {
  static propTypes = {
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    resetReduxModal: PropTypes.func.isRequired,
    hideReduxModal: PropTypes.func.isRequired,
  }

  onConfirm = async () => {
    const { onConfirm, resetReduxModal, hideReduxModal } = this.props
    if (typeof onConfirm === 'function') {
      await onConfirm()
    }
    hideReduxModal()
    setTimeout(() => {
      // Wait till fade out animation ends
      resetReduxModal()
    }, 150)
  }

  onCancel = async () => {
    const { onCancel, resetReduxModal, hideReduxModal } = this.props
    if (typeof onCancel === 'function') {
      await onCancel()
    }
    hideReduxModal()
    setTimeout(() => {
      // Wait till fade out animation ends
      resetReduxModal()
    }, 150)
  }

  render() {
    return (
      <ReduxModalView
        {...this.props}
        handleConfirm={this.onConfirm}
        handleCancel={this.onCancel}
      />
    )
  }
}

const mapStateToProps = ({ ui: { reduxModal } }) => {
  return reduxModal
}

const mapDispatchToProps = {
  hideReduxModal,
  resetReduxModal,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReduxModal)



// WEBPACK FOOTER //
// ./src/Components/ReduxModal/container/ReduxModal.js